export interface AuthContextType {
  logout: () => void;
  updateToken?: (token: string) => void;
  navigate?: (path: string) => void;
}

let authContextRef: AuthContextType | null = null;


export const setAuthContextRef = (authContext: AuthContextType) => {
  authContextRef = authContext;
};


export const httpInterceptor = {

  async intercept<T>(fetchPromise: Promise<Response>): Promise<Response> {
    try {
      const response = await fetchPromise;
      
      const newToken = response.headers.get('X-New-Access-Token');
      if (newToken && authContextRef?.updateToken) {
        authContextRef.updateToken(newToken);
      }
      
      if (response.status === 401) {
        if (authContextRef?.logout) {
          authContextRef.logout();
          if (authContextRef?.navigate) {
            authContextRef.navigate('/login?sessionExpired=true');
          } else {
            window.location.href = '/login?sessionExpired=true';
          }
        }
        
        throw new Error('SESSION_EXPIRED');
      }
      
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export const interceptedFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
  const fetchPromise = fetch(url, options);
  return httpInterceptor.intercept(fetchPromise);
};
